export function GroupVariantsByContext(items) {
  return items.reduce((acc, item) => {
    const context = item.Context;
    if (!acc[context]) {
      acc[context] = [];
    }
    acc[context].push(item);
    return acc;
  }, {});
}

export function categorizeByStepAndContext(data) {
  const result = {};

  data.forEach((item) => {
    const {
      SubStepTitle,
      Context,
      VariantID,
      Text,
      Image,
      Prerequisites,
      Cascades,
      CameraPosition,
      Url,
    } = item;

    if (!result[SubStepTitle]) {
      result[SubStepTitle] = {};
    }
    if (!result[SubStepTitle][Context]) {
      result[SubStepTitle][Context] = [];
    }

    result[SubStepTitle][Context].push({
      VariantID,
      Text,
      Image,
      Prerequisites,
      Cascades,
      CameraPosition,
      Url,
    });
  });

  return result;
}
